<script setup lang="ts">
const {meta} = useAppConfig();
useHead({
  title: `${meta.title}-关于我们`,
})
</script>

<template>
  <section class="pageAbout">
    <about-block1/>
    <about-block2 class="block2"/>
    <about-block3 class="block3"/>
    <glx-scroll-to-top/>
  </section>
</template>

<style scoped lang="scss">
.pageAbout {
  background: #F5F5F9;

  .block2 {
    margin-top: 113px;
  }

  .block3 {
    margin-top: 111px;
  }
}

</style>